module.exports = __webpack_public_path__ + "img/h.a1dded2e.jpg";